import { ReactComponent as Quastion } from 'assets/icons/header/question.svg';
import './styles.scss';
import { useDispatch, useSelector } from 'react-redux';
import { selectisContactFormOpen, setContactFormOpenOpen } from 'store/slices/UI-Slice';



const AskExpert = ({ text }) => {
    const dispatch = useDispatch()
    const isOpen = useSelector(selectisContactFormOpen);
    const handlePopupClick = () => {
        dispatch(setContactFormOpenOpen(!isOpen))
        document.documentElement.classList.toggle('unscrolled');
    };

    return (
        <div onClick={handlePopupClick} className='ask-expert'>
            <Quastion />
            {text}
        </div>
    );
}

export default AskExpert;